import { styled } from '@mui/material/styles';

import ActionButton from '@/components/ActionButton/index.ts';
import { Timer } from '@/ui/Timer.tsx';

import { MARCH_COMPETITION_END_DATE } from '../../../../config.ts';

const BoxContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(2),
  padding: theme.spacing(5),
  paddingTop: theme.spacing(7),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(5),
  },
}));

const Subtitle = styled('p')(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(2),
  fontSize: '22px',
  width: '79%',
  lineHeight: '36px',
  color: '#354661',
  marginTop: theme.spacing(4),

  [theme.breakpoints.down('md')]: {
    fontSize: '19px',
    width: '70%',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    width: '100%',
    lineHeight: '30px',
  },
}));

const StyledActionButton = styled(ActionButton)(({ theme }) => ({
  minWidth: 300,
  maxWidth: 300,
  maxHeight: 60,
  fontSize: '19px',
  width: '100%',
  backgroundColor: '#FA8331',
  borderColor: '#FA8331',
  color: '#fff',
  '&:hover': {
    borderColor: '#FA8331',
    color: '#FA8331',
  },
  [theme.breakpoints.up(395)]: {
    minWidth: 300,
  },
  [theme.breakpoints.up('sm')]: {
    minWidth: 300,
    maxHeight: 70,
  },
  [theme.breakpoints.up('md')]: {
    minWidth: 300,
  },
}));

const CountdownComponent = () => {
  return (
    <BoxContainer>
      <div>
        <Timer
          date={MARCH_COMPETITION_END_DATE}
          theme={{
            backgroundColor: '#18A0FB',
            digitsColor: '#FFFFFF',
          }}
        />
      </div>
      <Subtitle className="typography-v1-body1">
        2. April kl. 12:00 trekker vi en heldig vinner som får nedbetalt{' '}
        <strong>inntil 300.000 kr</strong> av sin gjeld.
      </Subtitle>
      <StyledActionButton
        label="Logg på og delta"
        step="init"
        flow="march_2024_campaign"
        color="secondary"
        gaEvent="march_competition_cta_clicked"
        labelClassName="action-button-text"
        sx={{
          '& .action-button-text': {
            width: '80%',
            fontSize: {
              xs: '19px',
              md: '22px',
            },
          },
        }}
      />
    </BoxContainer>
  );
};

export default CountdownComponent;
